(() => {

  const brandsTop = (classesToShow = [], classesToHide = []) => {
    classesToShow.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.classList.remove("hidden");
      });
    });

    classesToHide.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.classList.add("hidden");
      });
    });
  }

  const bannerTopRedesing = () => {
    const isHoldoutGroupEnabled = window._growthbook?.getFeatureValue(
      "holdout-pdm-corehandf",
      "OFF"
    );
    
    if ( isHoldoutGroupEnabled === "Holdout-q3-2026" ) {
      brandsTop(['.old-banner'], ['.new-multirow-header'])
    }else{
      brandsTop(['.new-multirow-header'],['.old-banner'])
    }
  }
  
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      bannerTopRedesing();
    };

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();

